import { Link } from 'react-router-dom'
import { Badge } from '@/components/ui/Badge'
import type { TaxRule } from '@/features/tax-rules/types/tax-rule.types'
import { latestVersionPath } from '@/features/tax-rules/utils/taxRuleVersions'

export function SupersededBadge({ rule }: { rule: TaxRule }): React.ReactElement {
  return <Badge variant="neutral">Superseded by v{rule.latestVersion}</Badge>
}

/** Badge plus a link to the latest version, for read-only views of an older version. */
export function SupersededNotice({ rule }: { rule: TaxRule }): React.ReactElement {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-700 dark:border-gray-700 dark:bg-gray-900/40 dark:text-gray-300">
      <SupersededBadge rule={rule} />
      <span>This is version {rule.version} and is read-only.</span>
      <Link className="font-medium text-primary hover:underline" to={latestVersionPath(rule)}>
        Open latest version
      </Link>
    </div>
  )
}
